/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { styled } from 'linaria/react';
import { useFormikContext } from 'formik';
import { SteamAccountPayee, TspPagePayee, useCyberStore } from '@entities/tsp';
import { authData, authHelper, AuthParams, useAuthDataStore } from '@entities/user';
import { PaymentFormValues, PaymentMethod } from '@entities/payment';
import { checkIsDenominationSoldOut } from '@entities/denomination';
import { eventContents, paymentLoginPayClickGtm, paymentPayClickGtm, productNames } from '@shared/lib/gtm/redesign';
import { useBreakpoint } from '@shared/lib/react';
import { Partners, usePartner } from '@shared/lib/partner';
import { scrollToFirstErrorField } from '@shared/lib';
import { Button } from '@shared/ui/molecules';
import { UserIcon } from '@shared/assets/icons';
import { Text } from '@shared/ui/atoms';
import { getTspEventContent } from '../../lib/getTspEventContent';
import { getClientTotalAmount } from '../../lib/getClientTotalAmount';
import OfferAgreementButton from './offer-agreement-modal/OfferAgreementButton';
interface PaySectionProps {
  payee: SteamAccountPayee | TspPagePayee;
  isPaymentloading: boolean;
  isAmountInfoLoading: boolean;
  isGetPriceLoading?: boolean;
}
const PaySection: FC<PaySectionProps> = ({
  payee,
  isPaymentloading,
  isAmountInfoLoading,
  isGetPriceLoading
}) => {
  const router = useRouter();
  const {
    partner
  } = usePartner();
  const {
    amountInfo,
    paymentMethod,
    isPromocodeActivated,
    requestID,
    pcekMdOrder
  } = useCyberStore();
  const {
    isAuth
  } = useAuthDataStore();
  const {
    isMobile
  } = useBreakpoint();
  const {
    values,
    validateForm,
    setFieldTouched
  } = useFormikContext<PaymentFormValues>();
  const isSteamPage = router.pathname === '/steam';
  const handleButtonClick = async () => {
    const eventContent = isSteamPage ? eventContents.servisy : getTspEventContent(payee);
    const productName = isSteamPage ? productNames.steam : payee?.providerName || '';
    const amount = String(getClientTotalAmount(amountInfo, isPromocodeActivated, true) || values.price || '').replace(/\s/g, '');
    if (!isAuth && paymentMethod === PaymentMethod.MTS_ACCOUNT) {
      paymentLoginPayClickGtm(eventContent, {
        productName,
        amount
      });
      authHelper.onSignIn();
      authHelper.mtsIdAuthorize(authData() as AuthParams).then(mtsId => {
        authHelper.redirectTo(mtsId);
      });
      return;
    }
    const formErrors = await validateForm();
    const errorFieldNames = Object.keys(formErrors || {});
    if (errorFieldNames.length) {
      errorFieldNames.forEach(key => setFieldTouched(key, true));
      scrollToFirstErrorField(errorFieldNames, isMobile);
      return;
    }
    paymentPayClickGtm(eventContent, {
      productName,
      amount,
      requestId: requestID,
      transactionId: pcekMdOrder,
      paymentMethod
    });
  };
  const isAuthNeededToPay = paymentMethod === PaymentMethod.MTS_ACCOUNT && !isAuth;
  const isAnyLoading = isPaymentloading || isAmountInfoLoading || Boolean(isGetPriceLoading);
  const isSoldOut = checkIsDenominationSoldOut(amountInfo);
  return <PayWrapper>
      <Button type={isAuthNeededToPay || isAnyLoading ? 'button' : 'submit'} size={{
      desktop: '72',
      mobile: '52'
    }} onClick={handleButtonClick} isLoading={!isAuthNeededToPay && isPaymentloading} isInactive={!isAuthNeededToPay && isAnyLoading} startIcon={isAuthNeededToPay && <UserIcon />} disabled={isSoldOut}>
        {isSoldOut ? 'Нет в наличии' : isAuthNeededToPay ? 'Войти для оплаты' : `Оплатить`}
      </Button>
      {!isAuthNeededToPay && partner === Partners.DEFAULT && <Text family="MTSCompact" size={{
      desktop: 'pS',
      mobile: 'captionL'
    }} weight="medium" color="tertiary">
          Нажимая кнопку «Оплатить», вы&nbsp;соглашаетесь{' '}
          <span style={{
        whiteSpace: 'nowrap'
      }}>
            с&nbsp;
            <OfferAgreementButton>офертой&nbsp;об&nbsp;оказании&nbsp;услуг</OfferAgreementButton>
          </span>
        </Text>}
    </PayWrapper>;
};
export default PaySection;
const PayWrapper = /*#__PURE__*/styled('div')({
  name: "PayWrapper",
  class: "pog12u",
  propsAsIs: false
});

require("./PaySection.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./PaySection.tsx");